import { createFileRoute } from '@tanstack/react-router'
import { POSPage } from '@/features/pos/pages/POSPage'

export const Route = createFileRoute('/_app/pos/')({
  component: POSPage,
})
